module.exports = __webpack_public_path__ + "img/A低通3.650bec26.png";